import RouterMiddleware from "./RouterMiddleware";
import AuthMiddleware from "./AuthMiddleware";
import AlertMiddleware from "./AlertMiddleware";
import RoleMiddleware from "./RoleMiddleware";
import GuestMiddleware from "./GuestMiddleware";

export default new RouterMiddleware({
	RequireAuth: AuthMiddleware,
	auth: AuthMiddleware,
	alert: AlertMiddleware,
	role: RoleMiddleware,
	guest: GuestMiddleware,
});
